<template>
    <!-- Router対応 -->
    <router-link v-if="to" :to="to" class="more">
        {{ text }}
    </router-link>

    <!-- 従来の外部リンク -->
    <a v-else :href="href" class="more">
        {{ text }}
    </a>
</template>

<script>
export default {
  name: 'MoreLink',

  props: {
    /* Router用（内部遷移） */
    to: {
      type: [String, Object],
      default: null
    },

    /* 外部リンク用（従来互換） */
    href: {
      type: String,
      default: null
    },

    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.more {
    display: block;
    width: 100px;
    margin: 0 auto;
    font-size: 18px;
    line-height: 40px;
    text-align: center;
    border-bottom: 1px solid #dddddd;
    padding-top: 80px;

    @media screen and (max-width: 722px) {
        padding-top: 60px;
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {}

    @media screen and (min-width: 964px) and (max-width: 1523px) {}

    @media screen and (min-width: 1524px) and (max-width: 2286px) {}

    @media screen and (min-width: 2287px) {}

    &:hover {
        opacity: 0.6;
        transition: 0.5s;
    }
}
</style>
